import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.mode === 'light' ? '#429E00' : '#308fe8'
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === 'light' ? '#182C55' : '#308fe8'
    }
}));

function CustomLinearProgress(values) {
    const limitAmount = Number(values.progressValue.limitAmount);
    const balance = Number(values.progressValue.balance);

    const percentBalance = (balance / limitAmount) * 100;

    return (
        <Box sx={{ flexGrow: 1 }}>
            <BorderLinearProgress variant="determinate" value={percentBalance} />
        </Box>
    );
}

export default CustomLinearProgress;
